import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Slot } from '../../types/slot';
import { getCasinosForSlot } from '../../utils/slots';
import { RealMoneyButton } from '../RealMoneyButton';
export function CasinoOfferList({
  slot
}: {
  slot: Slot;
}) {
  const list = getCasinosForSlot(slot).slice(0, 3);
  return <section aria-labelledby="offers-title" className="rounded-2xl border border-line bg-surface" data-id="element-338" data-mp="3868o31ur6slz">
      <div className="border-b border-line px-5 py-4" data-id="element-339" data-mp="9m04i6qmvr7t">
        <h2 id="offers-title" className="font-serif text-xl font-semibold" data-id="element-340" data-mp="4oi454qomkbf">
          Speel {slot.name} met echt geld
        </h2>
        <p className="mt-1 text-xs text-muted" data-id="element-341" data-mp="3w1ulhzxbi83t">Advertentie · 18+ · Voorwaarden van toepassing</p>
      </div>
      {list.length === 0 ? <p className="px-5 py-6 text-sm text-muted" data-id="element-342" data-mp="3r1qfj3u1cvru">
          Op dit moment biedt geen van onze partnercasino’s {slot.name} aan. Probeer de gratis demo.
        </p> : <ol className="divide-y divide-line" data-id="element-343" data-mp="nljbgw7pkwij">
          {list.map((c, i) => <li key={c.id} className="px-5 py-4" data-id="element-344" data-mp="2evjmx9elf11v" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-345" data-mp="2ewurvcjryeuk">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-serif font-semibold text-white" style={{
            backgroundColor: c.color
          }} aria-hidden="true" data-id="element-346" data-mp="2jsa3dxub7ynt">
                  {c.initials}
                </span>
                <div className="min-w-0 flex-1" data-id="element-347" data-mp="1w2fu1q978s8b">
                  <p className="truncate font-semibold" data-id="element-348" data-mp="2063yw16g59pv">{c.name}</p>
                  <p className="flex items-center gap-1 text-xs text-muted" data-id="element-349" data-mp="203huubirlcce">
                    <StarIcon className="h-3 w-3 fill-oranje text-oranje" aria-hidden="true" data-id="element-350" data-mp="1m7e4wuexbq5q" />
                    {c.rating} · Uitbetaling {c.payout.toLowerCase()}
                  </p>
                </div>
                {i === 0 && <span className="shrink-0 rounded-full bg-fern-soft px-2 py-0.5 text-[11px] font-semibold text-fern" data-id="element-351" data-mp="3lixe9a4530fx">
                    Onze keuze
                  </span>}
              </div>
              <p className="mt-3 font-semibold" data-id="element-352" data-mp="3f25ktictlhmv">{c.bonus}</p>
              <p className="text-sm text-muted" data-id="element-353" data-mp="3f4rqtdk2bp2z">{c.bonusDetail}</p>
              <RealMoneyButton slot={slot} casino={c} label="Speel nu" className="mt-3 w-full" data-id="element-354" data-mp="3a4dhls6q693d" />
            </li>)}
        </ol>}
    </section>;
}